import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ImportIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M19,6V18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V13a1,1,0,0,0-2,0v6a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2H13a1,1,0,0,0,0,2h5A1,1,0,0,1,19,6Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M14.83,8.83a1,1,0,0,0-1,1v2.59L4.7,3.29A1,1,0,0,0,3.29,4.7l9.13,9.13H9.83a1,1,0,0,0,0,2h5a1,1,0,0,0,1-1v-5A1,1,0,0,0,14.83,8.83Z"
  })]
}), 'ImportIcon');